const firebaseConfig = {
  apiKey: "AIzaSyA6lXpEGQ8rJizBOzyv049s1ccSVU9riF4",
  authDomain: "bicycle-center.firebaseapp.com",
  projectId: "bicycle-center",
  storageBucket: "bicycle-center.appspot.com",
  messagingSenderId: "155593868326",
  appId: "1:155593868326:web:3cd5b101e8db1c272a92e7",
};
export default firebaseConfig;
